import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import { useHeadingsObserver } from '@Theme/hellofinance/hooks/useHeadingsObserver';

import TableOfContentsItem from './TableOfContentsItem';
import Icon from '@Theme/hellofinance/components/Icon/Icon';

import * as styles from './TableOfContents.module.scss';

const propTypes = {
  /**
   * Heading of TOC
   */
  heading: PropTypes.string,

  /**
   * React reference
   */
  target: PropTypes.object,

  /**
   * Additional className
   */
  classname: PropTypes.string,

  /**
   * Additional id
   */
  id: PropTypes.string
};

// eslint-disable-next-line react/display-name
const TableOfContents = React.forwardRef(({
  heading,
  classname,
  id
},
target
) => {
  if (!heading && !target) {
    return false;
  }

  const tableOfContentsRef = useRef();

  const [
    headingNodesList,
    setHeadingNodesList
  ] = useState();

  const [
    arrayOfNodes,
    setArrayOfNodes
  ] = useState();

  const [
    isOpen,
    setIsOpen
  ] = useState(false);

  const handleClick = () => {
    setIsOpen(prev => !prev);
  };

  useEffect(() => {
    const sectionsHeadings = target.current.querySelectorAll('h2');
    let nodeList = [];

    sectionsHeadings.forEach(el => nodeList.push(el));

    setHeadingNodesList(nodeList);

    const arrayFromNodeList = Array.from(nodeList);

    setArrayOfNodes(arrayFromNodeList);
  }, [
    target,
    setHeadingNodesList,
    setArrayOfNodes
  ]);

  const activeClassname = `${styles.rootListLinkActive}`;

  const activeElement = useHeadingsObserver(headingNodesList, tableOfContentsRef, activeClassname);

  return <>
    <div className={`${styles.root} ${isOpen ? styles.rootIsOpen : ''} ${classname || ''}`} id={id}>
      {heading && <div className={styles.rootHeading}>{heading}</div>}
      {arrayOfNodes && <>
        <div className={styles.rootListWrapper}>
          <ul className={styles.rootList} ref={tableOfContentsRef}>
            {arrayOfNodes.map((item, index) => <TableOfContentsItem node={item} key={index}/>)}
          </ul>
        </div>
        <div className={styles.rootBody}>
          <div className={styles.rootBodyHeading}>{activeElement || heading}</div>
          <div className={styles.rootIconWrapper} onClick={handleClick}>
            <Icon classname={`${styles.rootIcon} ${styles.rootIconOpen}`} name='contentsOpen'/>
            <Icon classname={`${styles.rootIcon} ${styles.rootIconClose}`} name='contentsClose'/>
          </div>
        </div>
      </>}
    </div>
    <div className={styles.rootBackground} onClick={handleClick}/>
  </>;
});

TableOfContents.propTypes = propTypes;

export default TableOfContents;
